/**
 * 사업자 정보 (푸터·법적 고지 공통).
 * PG(토스페이먼츠) 카드사 심사 요건: 상호명·대표자명·사업자등록번호·통신판매업신고번호·사업장주소·유선전화번호가
 * 사업자등록증과 완전히 일치하게 사이트 하단에 노출되어야 한다. 값이 비어 있는 항목은 렌더링에서 생략된다.
 */
export const BUSINESS_INFO = {
    companyName: '주식회사 그로스가든',
    serviceName: '명치사',
    representative: '이서연',
    registrationNumber: '871-86-03795',
    /** 통신판매업신고번호 (예: 제2026-서울강남-00000호) — 신고 완료 후 기재 */
    mailOrderSalesNumber: '',
    /** 사업장 주소 — 층·호수까지 사업자등록증과 동일하게 기재 */
    address: '경기도 이천시 이섭대천로 1281, 201-7호(창전동)',
    /** 유선전화번호 (070/0505/대표번호/휴대폰 가능) */
    phone: '010-5192-4888',
    email: 'support@myungchisa.com',
} as const;
